import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component } from '@angular/core'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'

@Component({
  selector: 'app-archived-items-skeleton',
  standalone: true,
  imports: [NgClass, NgxSkeletonLoaderModule],
  templateUrl: './archived-items-skeleton.component.html',
  styleUrl: './archived-items-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-label': 'Loading archived items'
  }
})
export class ArchivedItemsSkeletonComponent {
  public readonly skeletonTheme = {
    backgroundColor: '#E5E7EB',
    color: '#D1D5DB'
  }

  public readonly rows = Array.from({ length: 5 }, (_, index) => index)

  /**
   * Build ngx-skeleton-loader theme for a shimmer element.
   */
  public theme(width: string, height: string, borderRadius = '4px'): Record<string, string> {
    return {
      width,
      height,
      'border-radius': borderRadius,
      backgroundColor: this.skeletonTheme.backgroundColor,
      color: this.skeletonTheme.color,
      marginBottom: '0'
    }
  }
}
